


// // Slider
// var slider = new KeenSlider(".keen-slider", {
//   loop: true,
//   vertical: true,
//   slides: {
//     origin: "center",
//     perView: 1,
//     spacing: 0,
//   },
// }, [ autoplay, navigation])

const Slider = new function() {
    let el;
    let slider;

    this.init = () => {
        el = document.querySelector('.keen-slider');
        if (!el) return;

        slider = new KeenSlider(el, {
            loop: true,
            vertical: true,
            slides: {
              origin: "center",
              perView: 1,
              spacing: 0,
            },
        }, [ autoplay, navigation]);

        // Navigation
        function navigation(slider) {
            let wrapper, dots
        
            function markup(remove) {
            wrapperMarkup(remove)
            dotMarkup(remove)
            }
        
            function removeElement(elment) {
            elment.parentNode.removeChild(elment)
            }
            function createDiv(className) {
            var div = document.createElement("div")
            var classNames = className.split(" ")
            classNames.forEach((name) => div.classList.add(name))
            return div
            }
        
        
            function wrapperMarkup(remove) {
            if (remove) {
                var parent = wrapper.parentNode
                while (wrapper.firstChild)
                parent.insertBefore(wrapper.firstChild, wrapper)
                removeElement(wrapper)
                return
            }
            wrapper = createDiv("navigation-wrapper")
            slider.container.parentNode.appendChild(wrapper)
            wrapper.appendChild(slider.container)
            }
        
            function dotMarkup(remove) {
            if (remove) {
                removeElement(dots)
                return
            }
            dots = createDiv("dots")
            slider.track.details.slides.forEach((_e, idx) => {
                var dot = createDiv("dot")
                dot.addEventListener("click", () => slider.moveToIdx(idx))
                dots.appendChild(dot)
            })
            wrapper.appendChild(dots)
            }
        
            function updateClasses() {
            var slide = slider.track.details.rel
            Array.from(dots.children).forEach(function (dot, idx) {
                idx === slide
                ? dot.classList.add("dot--active")
                : dot.classList.remove("dot--active")
            })
            }
        
            slider.on("created", () => {
            markup()
            updateClasses()
            })
            slider.on("optionsChanged", () => {
            console.log(2)
            markup(true)
            markup()
            updateClasses()
            })
            slider.on("slideChanged", () => {
            updateClasses()
            })
            slider.on("destroyed", () => {
            markup(true)
            })
        }

        // Autoplay
        function autoplay(slider) {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
            clearTimeout(timeout)
            }
            function nextTimeout() {
            clearTimeout(timeout)
            if (mouseOver) return
            timeout = setTimeout(() => {
                slider.next()
            }, 5000)
            }
            slider.on("created", () => {
            slider.container.addEventListener("mouseover", () => {
                mouseOver = true
                clearNextTimeout()
            })
            slider.container.addEventListener("mouseout", () => {
                mouseOver = false
                nextTimeout()
            })
            nextTimeout()
            })
            slider.on("dragStarted", clearNextTimeout)
            slider.on("animationEnded", nextTimeout)
            slider.on("updated", nextTimeout)
        }

    }
}

export default Slider;